module.exports = __webpack_public_path__ + "static/img/02.6a905fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02.png
// module id = 2p9i
// module chunks = 2